import * as Types from '../../../graphql.generated';

import { gql } from '@apollo/client';
export type ListingFragment = { __typename?: 'ListingData' } & Pick<
    Types.ListingData,
    | 'listingId'
    | 'displayAddress'
    | 'category'
    | 'section'
    | 'title'
    | 'publicationStatus'
    | 'publishedOn'
    | 'numberOfImages'
> & {
        location?: Types.Maybe<
            { __typename?: 'ListingLocation' } & Pick<
                Types.ListingLocation,
                'postalCode' | 'streetName'
            >
        >;
        branch?: Types.Maybe<
            { __typename?: 'AgentBranch' } & Pick<
                Types.AgentBranch,
                'logoUrl' | 'name'
            >
        >;
        featurePreview?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Feature' } & Pick<
                        Types.Feature,
                        'iconId' | 'content'
                    >
                >
            >
        >;
        imagePreview?: Types.Maybe<
            { __typename?: 'Image' } & Pick<Types.Image, 'caption' | 'src'> & {
                    responsiveImgList?: Types.Maybe<
                        Array<
                            Types.Maybe<
                                { __typename?: 'ResponsiveImg' } & Pick<
                                    Types.ResponsiveImg,
                                    'src' | 'width'
                                >
                            >
                        >
                    >;
                }
        >;
        listingUris: { __typename?: 'ListingUris' } & Pick<
            Types.ListingUris,
            'contact' | 'detail'
        >;
        pricing: { __typename?: 'ListingPricing' } & Pick<
            Types.ListingPricing,
            'label'
        >;
        tags?: Types.Maybe<
            Array<
                { __typename?: 'ListingTag' } & Pick<Types.ListingTag, 'label'>
            >
        >;
        transports?: Types.Maybe<
            Array<
                Types.Maybe<
                    { __typename?: 'Transport' } & Pick<
                        Types.Transport,
                        'distanceInMiles' | 'poiType' | 'title'
                    >
                >
            >
        >;
        statusSummary?: Types.Maybe<
            { __typename?: 'ListingStatusSummary' } & Pick<
                Types.ListingStatusSummary,
                'label'
            >
        >;
    };

export const ListingFragmentDoc = gql`
    fragment LISTING on ListingData {
        listingId
        displayAddress
        category
        location {
            postalCode
            streetName
        }
        section
        branch {
            logoUrl
            name
        }
        featurePreview {
            iconId
            content
        }
        imagePreview {
            caption
            src
            responsiveImgList {
                src
                width
            }
        }
        listingUris {
            contact
            detail
        }
        pricing {
            label
        }
        tags {
            label
        }
        title
        transports {
            distanceInMiles
            poiType
            title
        }
        publicationStatus
        publishedOn
        numberOfImages
        statusSummary {
            label
        }
    }
`;
